<template>
  <v-card dflex>
    <v-toolbar color="primary" flat dark prominent>
      <v-toolbar-title>{{ dealer.name }}</v-toolbar-title>
      <v-spacer/>
      <v-card-subtitle class="white--text">Campaign Performance Summary Report</v-card-subtitle>
      <v-btn
        color="primary"
        fab
        right
        x-small
        elevation="0"
        v-on:click.prevent="$emit('close-report')"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { ReportsApi } from '@/services'
import { downloadViaLinkCreated, hasValue } from '@/utils'

export default {
  name: 'campaign-performance-summary-report',
  components: { },
  props: {
    // when set to true, indicate report should be executed now
    runReport: {
      required: true,
      type: Boolean
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    daysBetween: {
      type: Number
    },
    emailCampaigns: {
      type: Array
    },
    campaignTimespan: {
      type: Number
    },
    outputFormat: {
      type: String,
      required: false,
      default: 'html'
    }
  },
  data: function () {
    return {
      salesColor: 'teal',
      servicesColor: 'cyan',
      mailStatsData: [],
      dollarTextShrink: {
        default: {
          // width: 200,
          valueClass: 'headline ml-2 mb-8'
        }
      }
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer'])
  },
  watch: {
    runReport (newVal, oldVal) {
      if (newVal) {
        this.loadCampaignSummaries()
      }
    }
  },
  methods: {
    shouldDownload () {
      return ['excel', 'csv'].includes(this.outputFormat)
    },
    validate () {
      if (hasValue(this.startDate) && hasValue(this.endDate) &&
             hasValue(this.daysBetween) && hasValue(this.campaignTimespan) &&
             this.emailCampaigns.length > 0) {
        return true
      } else {
        throw new Error('Invalid/Missing Parameters')
      }
    },
    async loadCampaignSummaries () {
      this.$logger.trace('Loading CampaignSummary Data')
      try {
        this.validate()
        const rptParams = {
          name: 'CampaignPerformanceSummary',
          dealer_id: this.dealer.id,
          start_date: this.startDate,
          end_date: this.endDate,
          days_between: this.daysBetween,
          campaign_timespan: this.campaignTimespan,
          email_campaigns: this.emailCampaigns,
          include_backing_data: this.shouldDownload(),
          output_format: this.outputFormat
        }
        const rptData = await ReportsApi.generateReport(rptParams)
        if (this.shouldDownload()) {
          downloadViaLinkCreated(rptData.data.csv_url)
        } else {
          this.mailStatsData = rptData.data
        }

        this.$emit('report-complete', { status: 'ok' })
      } catch (error) {
        this.$logger.error('Error Fetching report', error.message)
        this.$emit('report-complete', { status: 'error', message: error.message })
      }
    }
  }

}
</script>
